var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5781 24H5.625C3.55719 24 1.875 22.3178 1.875 20.25V7.54688C1.875 5.47906 3.55719 3.79688 5.625 3.79688H14.5781C16.6459 3.79688 18.3281 5.47906 18.3281 7.54688V20.25C18.3281 22.3178 16.6459 24 14.5781 24ZM5.625 5.67188C4.59119 5.67188 3.75 6.51306 3.75 7.54688V20.25C3.75 21.2838 4.59119 22.125 5.625 22.125H14.5781C15.6119 22.125 16.4531 21.2838 16.4531 20.25V7.54688C16.4531 6.51306 15.6119 5.67188 14.5781 5.67188H5.625ZM22.0781 17.9062V3.75C22.0781 1.68219 20.3959 0 18.3281 0H7.92188C7.40405 0 6.98438 0.419678 6.98438 0.9375C6.98438 1.45532 7.40405 1.875 7.92188 1.875H18.3281C19.3619 1.875 20.2031 2.71619 20.2031 3.75V17.9062C20.2031 18.4241 20.6228 18.8438 21.1406 18.8438C21.6584 18.8438 22.0781 18.4241 22.0781 17.9062Z",
    fill: "#525975"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.8fa1fdb5.svg";
export { ForwardRef as ReactComponent };